export default {
    wagonStatus: [
      "ready",
      "inProgress",
      "nearComplete",
      "completedOk",
      "completedWithError",
      "reportedManually"
    ],
    languages: {
      'English': 'en',
      'Hebrew': 'he'
    },
    currencyList : {
      BGN: "лв", CHF: "CHF", BRL: "R$", CAD: "$", CLP: "$", COP: "$", CZK: "Kč", DKK: "kr", EUR: "€", GBP: "£", GEL: "₾", HRK: "kn", HUF: "ft", ILS: "₪", MXN: "$", NOK: "kr", PEN: "S/.", PLN: "zł", RON: "lei", RUB: "₽", SEK: "kr", TRY: "₺", UAH: "₴", USD: "$", ZAR: "R"
    },

    Profile: {},
    drawer: false,

    Feeds: [],
    FeedUnsubscribe: function () {},

    TMRs: [],
    TmrsUnsubscribe: function () {},

    Groups: [],
    GroupUnsubscribe: function () {},

    Recipes: [],
    RecipeUnsubscribe: function () {},

    GroupTypes: [
      'Unspecified',
      'Lactating Early',
      'Lactating Middle',
      'Lactating Late',
      'Heifers',
      'Calves',
      'Bulls',
      'Special'
    ],


    user: null,

    Wagons: [],
    selectedDays: [],

    //dashboard graph data
    labels: [],
    todayMake: [],
    todayDeliver: [],
    yesterdayMake: [],
    yesterdayDeliver: [],

    Equipments: []
}